module.exports = "./img/e4ac319f255287fbcd5561154ead390d.jpg";